import React from 'react'
import R from 'ramda'
import FormDataMixin from 'react-form-data'
import { Redirect } from 'react-router-dom'
import { MTMessageController } from 'mt-ui'
import conf from '@mediatool/mt-frontend/lib/conf'

const createClass = require('create-react-class')

module.exports = function (loginRequests, messageCenter) {
  const AdminLogin = createClass({

    mixins: [ FormDataMixin ],

    performLogin (loginDetails) {
      const data = R.assoc('stayLoggedIn', this.state.stayLoggedIn, loginDetails)

      loginRequests.loginAdmin(data)
        .fork(messageCenter.error, (_) => {
          window.location = '/'
        })
    },

    onSubmit (e) {
      e.preventDefault()
      this.performLogin(this.formData)
    },

    getInitialState () {
      return { stayLoggedIn: false }
    },

    componentDidMount () {
      this.email.focus()
    },

    toggleStayLoggedIn () {
      this.setState({
        stayLoggedIn: !this.state.stayLoggedIn,
      })
    },

    quickLogin () {
      const quickLogin = {
        password: 'aaaaaaaa',
        username: 'andy@mediatool.com',
      }
      this.performLogin(quickLogin)
    },

    render () {
      const { stayLoggedIn } = this.state

      return (
        <div className="page">
          <div className="ball-1" />
          <div className="ball-2" />
          <div className="ball-3" />
          <div className="ball-4" />
          <div className="ball-5" />
          <div className="ball-6" />
          <div className="ball-7" />
          <div className="ball-8" />
          <MTMessageController messageCenter={ messageCenter } />
          <div className="logo" />
          <div className="letters">
            <span className="letter">T</span>
            <span className="letter">O</span>
            <span className="letter">T</span>
            <span className="letter">T</span>
          </div>
          <div className="login-form">
            <form onChange={ this.updateFormData } onSubmit={ this.onSubmit }>
              <div className="input">
                <label>Email:</label>
                <input ref={ (e) => { this.email = e } } type="text" name="username" placeholder="E-mail" />
              </div>
              <div className="input">
                <label>Password:</label>
                <input type="password" name="password" placeholder="Password" />
              </div>
              <div className="login-form__footer">
                <div className="remember" onClick={ this.toggleStayLoggedIn }>
                  <span className={ `checkbox ${stayLoggedIn ? 'checked' : ''}` } />
                  { ' ' }Stay logged in
                </div>
                { conf.devFeatures && (
                  <a className="login-form__quickLogin" onClick={ this.quickLogin }>Quick login</a>
                ) }
                <input className="button" type="submit" value="Login" />
              </div>
            </form>
          </div>
          <Redirect from="*" to="/login" />
        </div>
      )
    },
  })
  return AdminLogin
}
